import { render, staticRenderFns } from "./ProWorksheetPhysicalExam.vue?vue&type=template&id=61aec646&scoped=true&"
import script from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"
export * from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"
import style0 from "./ProWorksheetPhysicalExam.vue?vue&type=style&index=0&id=61aec646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aec646",
  null
  
)

export default component.exports